import { render, staticRenderFns } from "./MailNG.vue?vue&type=template&id=6eef731d&scoped=true&"
import script from "./MailNG.vue?vue&type=script&lang=js&"
export * from "./MailNG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eef731d",
  null
  
)

export default component.exports